import React from 'react';
import { useTranslations } from '../translations/translations';

const Hero = ({ onScrollToContact }) => {
  const t = useTranslations();
  
  return (
    <section className="hero-section">
      <div className="hero-background">
        <video 
          autoPlay 
          muted 
          loop 
          playsInline
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            filter: 'grayscale(100%) brightness(1.3) contrast(0.9)'
          }}
        >
          <source src="/videos/bodyguard-demo.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1 className="hero-title">
          {t.hero.title} <span style={{ fontSize: '0.6em', fontWeight: 300 }}>{t.hero.titleSmall}</span>
        </h1>
        <h2 className="hero-main-subtitle">
          {t.hero.mainSubtitle}
        </h2>
        
        <div className="hero-locations">
          <div className="location">
            <div className="location-name">{t.hero.locations.paris}</div>
            <div className="location-detail">30 Rue Pasteur, Suresnes</div>
          </div>
          <div className="location">
            <div className="location-name">{t.hero.locations.monaco}</div>
            <div className="location-detail">Le Patio Palace, 41 Avenue Hector Otto</div>
          </div>
        </div>

        <a href="#contact" className="hero-cta" onClick={(e) => { e.preventDefault(); onScrollToContact(); }}>
          {t.hero.cta}
        </a>
      </div>
    </section>
  );
};

export default Hero;
